










import { Component, Vue } from 'vue-property-decorator';

import AppEgrnFreeForm from 'shared/module/EgrnFreeForm/EgrnFreeForm.vue';
import { isCadastralNumber } from 'shared/utils/cadastralNumber';
import { AppState } from 'shared/module/EgrnFreeForm/util/app-state';

@Component({
  components: { AppEgrnFreeForm },

  props: {
    formType: {
      type: String,
      default: 'advanced',
    },
  },
})
export default class App extends Vue {
  // methods
  async getProducts(state: AppState['form']) {
    let products: Product[] = [];
    const params: any = {};

    if (isCadastralNumber(state.query)) {
      params.kadastrNumber = state.query;
    }

    if (state.person_role) {
      params.personRoleID = state.person_role;
    }

    try {
      products = await this.$api.products.List(null, params);
    } catch (error) {
      console.error(error);
    }

    return products;
  }
}
